import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { postForeignCurrency } from '@/api/fx';
import { PostForeignCurrencyBody } from '@/types/fx.type';
import { useAppDispatch } from './useReduxHooks';
import { updateLoading } from '@/store/loading.store';

interface UsePostForeignCurrencyProps {
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

export const usePostForeignCurrency = ({
  onSuccess,
  onError,
}: UsePostForeignCurrencyProps = {}) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isLoading, isError, error, isSuccess, data } =
    useMutation<number, AxiosError, PostForeignCurrencyBody>(
      (payload) => {
        dispatch(updateLoading({ isLoading: true }));
        return postForeignCurrency(payload);
      },
      {
        onSuccess: () => {
          // 외화 수납 후 외화 수납 내역 캐시 무효화
          queryClient.invalidateQueries('foreignCurrencyHistory');

          if (onSuccess) {
            onSuccess();
          }

          dispatch(updateLoading({ isLoading: false }));
        },
        onError: (error) => {
          console.error('Foreign currency payment error:', error);

          if (onError) {
            onError(error);
          }

          dispatch(updateLoading({ isLoading: false }));
        },
        retry: 0,
      },
    );

  return {
    createForeignCurrency: mutate,
    createForeignCurrencyAsync: mutateAsync,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
  };
};
